module.exports = __webpack_public_path__ + "static/image/history/pc/202106@3x.ver2_0_2.jpg?2a2f0a96";